const parseCookie = cookies => {
  let cookie = ''
  Object.keys(cookies).forEach(item => {
    cookie += item + '=' + cookies[item] + '; '
  })
  return cookie
}

export { parseCookie }



// WEBPACK FOOTER //
// ./src/util/parseCookie.js